// extracted by mini-css-extract-plugin
export default {"page":"GMUIdh","header":"Felurv","badges":"X3zlzI","headerActions":"EBtTv1","danger":"Y8XuT1","meta":"IZceLQ","history":"cNxDK5","loading":"Xf6r_x","komodoError":"DBYBPw"};